import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';

const MODALS: {
  [modalName: string]: { [id: string]: () => boolean | undefined };
} = {};

// @ts-ignore
window.MODALS = MODALS;

export const useModalWrapper = (name: string): (() => boolean) => {
  useEffect(() => {
    if (!MODALS[name]) {
      MODALS[name] = {};
    }

    return () => {
      delete MODALS[name];
    };
  }, [name]);
  return () => {
    const promises = Object.values(MODALS[name] || {});
    if (!promises?.length) return true;
    return promises.map((p) => p()).every(Boolean);
  };
};

export const useModalClose = (name: string, fuc: () => boolean) => {
  const id = uuid();

  useEffect(() => {
    if (!MODALS[name]) {
      MODALS[name] = {};
    }
    MODALS[name][id] = fuc;
    return () => {
      if (MODALS[name] && MODALS[name][id]) {
        delete MODALS[name][id];
      }
    };
  }, [name, fuc]);
};
